import { render, staticRenderFns } from "./oneC.vue?vue&type=template&id=72c956e0&scoped=true&"
import script from "./oneC.vue?vue&type=script&lang=js&"
export * from "./oneC.vue?vue&type=script&lang=js&"
import style0 from "./oneC.vue?vue&type=style&index=0&id=72c956e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c956e0",
  null
  
)

export default component.exports